import {isAnalysisToolBoxPlotEnabled} from 'analysis-tool/AnalysisToolFeatureGates';
import {PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStep} from 'pipelines/PipelineTypes';

import {STEP_CONFIG_SETTINGS, STEP_CONFIG_SETTINGS_V2} from './step-config-settings/StepConfigSettings';

export type ConfigEditorStepType = keyof typeof STEP_CONFIG_SETTINGS | keyof typeof STEP_CONFIG_SETTINGS_V2;

export type ConfigEditorStepTypeVersion<StepType extends ConfigEditorStepType> =
  keyof (typeof STEP_CONFIG_SETTINGS)[StepType & keyof typeof STEP_CONFIG_SETTINGS] extends number
    ? keyof (typeof STEP_CONFIG_SETTINGS)[StepType & keyof typeof STEP_CONFIG_SETTINGS]
    : never;

export function isV2ConfigEditorStepType(
  stepType: PipelineStepType
): stepType is keyof typeof STEP_CONFIG_SETTINGS_V2 {
  return STEP_CONFIG_SETTINGS_V2.hasOwnProperty(stepType);
}

/**
 * Check if a step type can be configured (to edit or to create) using the generic step config editor.
 */
export function stepTypeIsConfigEditorSupported(
  stepType: PipelineStepType,
  stepVersion: number
): stepType is ConfigEditorStepType {
  if (stepType === PipelineStepType.CHART_VIEW) {
    return isAnalysisToolBoxPlotEnabled();
  }
  if (isV2ConfigEditorStepType(stepType)) {
    const settings = STEP_CONFIG_SETTINGS_V2[stepType];
    return stepVersion < settings.length && settings[stepVersion] != null;
  }
  const settings = STEP_CONFIG_SETTINGS[stepType as keyof typeof STEP_CONFIG_SETTINGS] ?? [];
  return stepVersion < settings.length && settings[stepVersion] != null;
}

/**
 * Check if a step can be edited using the generic step config editor.
 */
export function stepIsConfigEditorSupported(
  step: PipelineStep
): step is PipelineStep<ConfigEditorStepType, ConfigEditorStepTypeVersion<ConfigEditorStepType>> {
  return stepTypeIsConfigEditorSupported(step.stepType, step.stepVersion);
}

export function isUiSchemaForStepTypeV2(
  stepType: ConfigEditorStepType
): stepType is keyof typeof STEP_CONFIG_SETTINGS_V2 {
  return STEP_CONFIG_SETTINGS_V2.hasOwnProperty(stepType);
}
